var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttachmentIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9 12.4L12.25 21.05C11.1908 22.1092 9.75418 22.7043 8.25625 22.7043C6.75832 22.7043 5.32173 22.1092 4.2625 21.05C3.20327 19.9908 2.6082 18.5542 2.6082 17.0563C2.6082 15.5583 3.20327 14.1218 4.2625 13.0625L12.9125 4.4125C13.6186 3.70634 14.5763 3.30963 15.575 3.30963C16.5736 3.30963 17.5314 3.70634 18.2375 4.4125C18.9436 5.11866 19.3404 6.07641 19.3404 7.07504C19.3404 8.07367 18.9436 9.03142 18.2375 9.73758L9.57812 18.3876C9.22505 18.7406 8.74617 18.939 8.24688 18.939C7.74758 18.939 7.2687 18.7406 6.91563 18.3876C6.56255 18.0345 6.36421 17.5556 6.36421 17.0563C6.36421 16.557 6.56255 16.0781 6.91563 15.7251L14.9094 7.74071",
    stroke: "#1A1A1A",
    strokeWidth: 1.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachmentIcon);
export default __webpack_public_path__ + "static/media/AttachmentIcon.e42f466edae8b7530ce505f6797a73dd.svg";
export { ForwardRef as ReactComponent };